// extracted by mini-css-extract-plugin
export default {"tabList":"JyGO35xZTcGHRx16Ee9z","marginBottom":"QBqscGNUt5vHxCMSezXw","tabButton":"rArkpp4B2a5vcIq8g44k","selected":"V9hSCXFmF2h31Xqz94zi"};